import { Modal } from "antd";
import styled from "styled-components";
export const Content = styled(Modal)`
  .ant-modal-content {
    border-radius: 8px;
  }
  .ant-modal-header {
    border-radius: 8px;
  }
  .ant-modal-body {
    min-height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
  }

  .actions {
    width: "100%";
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 15px;
  }
  .title {
    font-size: 18px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.secondary100};
  }
  .description {
    font-size: 16px;
    color: ${({ theme }) => theme.colors.secondary70};
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 30px;

  }
.error-message{
  color: red;
  font-size: 12px;
  margin-top: 10px;
  margin-bottom: 10px;
}
  .form-group {
    display: flex;
    align-items: center;
    justify-content: space-around;
    span {
      font-size: 16px;
      margin-bottom: 5px;
      font-weight: 500;
    }
  }
`;
